// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"style-module_menuItem__1Fgzit1_x7mK2AWv-hUJPb","content":"style-module_content__iFqHn6cA0-cp8D61Mz_SU"};